module.exports = __webpack_public_path__ + "img/ribbon.2705a858.png";